
import { defineComponent } from "vue";

export default defineComponent({
	emits: ["back-to-music-btn-clicked"],
	setup(any, { emit })
	{
		function onClick()
		{
			emit("back-to-music-btn-clicked")
		}
		return {
			onClick
		};
	},
});
